import { Hashtag } from './Hashtag'
import { withHashtag } from './withHashtag'

const ConnectedHashtag = withHashtag(Hashtag)

export { ConnectedHashtag as Hashtag }
